import { FC, ReactNode } from "react";
import { Link } from "react-router-dom";
import { useNetworkRoute } from "../../hooks/useNetworkRoute";

type Props = {
  className?: string;
  path: string;
  fragment?: string;
  children: ReactNode;
};

/**
 * React router has a bug where it fully decodes multiple URL encoded values
 * It was an existing issue for useParams in versions prior to 6.22.1 but it still has
 * the same issue on Link component
 *
 * This component corrects the issue by manually encoding the value
 */

export const getRoute = (
  path: string,
  type?: string,
  value?: string,
  fragment?: string
) => {
  if (!type || !value) return "";
  const encodedUrl = encodeURIComponent(value);
  const route = `/${type}/${encodedUrl}/${path}`;
  return fragment ? `${route}#${fragment}` : route;
};

const NetworkLink: FC<Props> = ({ path, className, fragment, children }) => {
  const [type, value] = useNetworkRoute();

  const route = getRoute(path, type, value, fragment);

  return (
    <Link className={className} to={route}>
      {children}
    </Link>
  );
};

export default NetworkLink;
